import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function getLastSevenDays() {
  const dates = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    dates.push(`${d.getMonth() + 1}/${d.getDate()}`);
  }
  return dates.reverse(); // To get dates in ascending order (oldest to newest)
}

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'Retried Rules Over Last 7 Days',
    },
  },
};

const labels = getLastSevenDays();

const RetryBarChart = (props) => {
  const { retryRules } = props;
  const today = new Date().getDay();

  console.log({ today, lsd: getLastSevenDays() });

  const data = {
    labels,
    datasets: [
      {
        label: 'Number of Retry Rules',
        data: labels
          .map((label) => {
            const dayIndex = labels.indexOf(label);
            const retryCount = retryRules.filter((rule) => {
              const ruleDate = new Date(rule.createdAt);
              return ruleDate.getDay() === (today - dayIndex + 7) % 7; // Adjust for the last 7 days
            }).length;
            return retryCount;
          })
          .reverse(),
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
      // {
      //   label: 'Dataset 2',
      //   data: [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200],
      //   backgroundColor: 'rgba(53, 162, 235, 0.5)',
      // },
    ],
  };

  return <Bar options={options} data={data} />;
};

export default RetryBarChart;
